import { DescriptionParams } from '../localeParams'

const cmdsEN: DescriptionParams = {
  description: '💎 Solana Validator All-in-One CLI 💎',
  version: 'Output the current version',
  help: 'Display help for solv commands',
  subcmdHelp: 'Display help for subcommands',
  server: 'Open solv Dashboard',
  start: 'Start Solana Validator',
  stop: 'Stop Solana Validator',
  status: 'Show Solana Validator Status',
  restart: 'Restart Solana Validator',
  update: 'Update Solana Validator Version',
  get: 'Get Solana Validator Info Commands',
  log: 'Tail Solana Validator Log',
  catchup: 'Catchup Solana Validator',
  monitor: 'Monitor Solana Validator',
  config: 'Show Solana Validator Config',
  install: 'Install/Update Solana Version',
  stake: 'Solana Delegate Stake',
  check: 'Check Solana Validator',
  scp: 'Download/Upload Solana Validator Keypairs',
  cron: 'Run Schedule Tasks',
  setup: 'Setup Solana Validator',
  epoch: 'Show Current Epoch',
  slot: 'Show Current Slot',
  solv: 'Endroll Solv AA',
  installer: 'Please select an option:',
  unstake: 'UnStake',
}

export default cmdsEN
